// src/api/APIGateway.js
import axios from 'axios'

// =======================
// TOKEN UTILS
// =======================
function getCookie(key) {
    const cookies = document.cookie
        .split(';')
        .map(cookie => cookie.split('='))
        .reduce((acc, [k, v]) => {
            acc[k.trim()] = decodeURIComponent(v)
            return acc
        }, {})
    return cookies[key]
}

function getFormData(params) {
    const form = new FormData()
    Object.keys(params).forEach(key => {
        form.append(key, params[key])
    })
    return form
}

export function setTokenData(access_token, refresh_token, expires_in) {
    const expireTime = Date.now() + expires_in * 1000
    localStorage.setItem('access_token', access_token)
    localStorage.setItem('refresh_token', refresh_token)
    localStorage.setItem('token_expire', expireTime)
}

function clearTokenData() {
    localStorage.removeItem('access_token')
    localStorage.removeItem('refresh_token')
    localStorage.removeItem('token_expire')
}

function getAccessToken() {
    return localStorage.getItem('access_token')
}

function getRefreshToken() {
    return localStorage.getItem('refresh_token')
}

function getTokenExpire() {
    return Number(localStorage.getItem('token_expire'))
}

// =======================
// REFRESH TOKEN LOGIC
// =======================
let isRefreshing = false
let refreshSubscribers = []

function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb)
}

function onRefreshed(newToken) {
    refreshSubscribers.forEach(cb => cb(newToken))
    refreshSubscribers = []
}

async function refreshToken() {
    if (isRefreshing) {
        return new Promise(resolve => {
            subscribeTokenRefresh(token => resolve(token))
        })
    }

    isRefreshing = true
    try {
        const refresh_token = getRefreshToken()
        const formData = new FormData()
        formData.append('grant_type', 'refresh_token')
        formData.append('refresh_token', refresh_token)
        formData.append('client_id', process.env.VUE_APP_SSO_CLIENT_ID)
        formData.append('client_secret', process.env.VUE_APP_SSO_CLIENT_SECRET)

        const res = await axios.post(`${process.env.VUE_APP_SSO_AUTHORITY}/protocol/openid-connect/token`, formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })

        const data = res.data
        setTokenData(data.access_token, data.refresh_token, data.expires_in)

        isRefreshing = false
        onRefreshed(data.access_token)
        return data.access_token
    } catch (err) {
        isRefreshing = false
        clearTokenData()
        window.location.href = '/login'
        throw err
    }
}

// =======================
// MAIN TOKEN CHECK
// =======================
async function ensureValidToken() {
    const expireTime = getTokenExpire()
    const token = getAccessToken()

    // Nếu token sắp hết hạn trong 1 phút, refresh

    if (token && expireTime && Date.now() > expireTime - 60000) {

        await refreshToken()
    }
}

async function withAuthRequest(fn) {
    try {
        await ensureValidToken()
        return await fn()
    } catch (err) {
        if (err.response && err.response.status === 401) {
            await refreshToken()
            return await fn()
        }
        throw err
    }
}

// =======================
// HTTP METHODS
// =======================
export async function get(params, url) {
    return await withAuthRequest(async () => {
        const token = getAccessToken()
        return axios.get(process.env.VUE_APP_API_URL + url, {
            params,
            headers: { Authorization: `Bearer ${token}` }
        })
    })
}

export async function post(params, url) {
    return await withAuthRequest(async () => {
        const token = getAccessToken()
        const data = params instanceof FormData ? params : getFormData(params)
        return axios.post(process.env.VUE_APP_API_URL + url, data, {
            headers: { Authorization: `Bearer ${token}` }
        })
    })
}
export async function post_1(params, url) {
    return await withAuthRequest(async () => {
        const token = getAccessToken()
        const data = params instanceof FormData ? params : getFormData(params)
        return axios.post( url, data, {
            headers: { Authorization: `Bearer ${token}` }
        })
    })
}

export async function getExternal(url, params) {
    return await withAuthRequest(async () => {
        const token = getAccessToken()
        return axios.get(url, {
            params,
            headers: { Authorization: `Bearer ${token}` }
        })
    })
}

export async function get_1(params, url) {
    const token = getAccessToken();
    const res = await axios.get(url,
        {
            params,
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    )

    return res
}

export async function get_3(params, url) {
    const username = params.username
    const target = process.env.VUE_APP_API_URL + url + '/' + username
    const token = getAccessToken();
    const res = await axios.get(target,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    )
    return res
}
